import React from "react";
import { Skeleton, Fade } from "@mui/material";

const MySkeleton = ({ lineCount = 3, lineHeights = [], widthPattern = [], timeout = 300 }) => {
  return (
    <Fade in timeout={timeout}>
      <div>
        {[...Array(lineCount)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            height={lineHeights[index] || 20}
            width={widthPattern[index] ? widthPattern[index] + "%" : `${40 + Math.random() * 40}%`}
            style={{ marginTop: index === 0 ? 0 : 8 }}
          />
        ))}
      </div>
    </Fade>
  );
};

export default MySkeleton;
